import { useRef, useEffect, useState } from 'react';
import './ScrollingText.css';

const ScrollingText = ({ text, className = '', innerClassName = '' }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [direction, setDirection] = useState(1);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [scrollable, setScrollable] = useState(false);
  const rafRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const textEl = textRef.current;
    if (!container || !textEl) return;

    const overflow = textEl.scrollWidth - container.offsetWidth;
    setScrollable(overflow > 0);
  }, [text]);

  useEffect(() => {
    if (!shouldScroll || !scrollable) return;

    const container = containerRef.current;
    const textEl = textRef.current;
    const maxOffset = textEl.scrollWidth - container.offsetWidth;

    const step = () => {
      setOffset(prev => {
        let next = prev + direction * 0.3;
        if (next >= maxOffset || next <= 0) {
          setDirection(-direction);
          next = Math.max(0, Math.min(maxOffset, next));
        }
        return next;
      });
      rafRef.current = requestAnimationFrame(step);
    };

    rafRef.current = requestAnimationFrame(step);

    return () => cancelAnimationFrame(rafRef.current);
  }, [shouldScroll, direction, scrollable]);

  return (
    <span
      ref={containerRef}
      className={`scrolling-text ${className}`.trim()}
      onMouseEnter={() => setShouldScroll(true)}
      onMouseLeave={() => {
        setShouldScroll(false);
        setOffset(0);
        setDirection(1);
      }}>
      <span
        ref={textRef}
        className={`scrolling-text__content ${innerClassName}`.trim()}
        style={{ transform: `translateX(-${offset}px)` }}>
        {text}
      </span>
    </span>
  );
};

export default ScrollingText;
